import React from 'react';
import cx from 'classnames';
import { getColorClass } from '../../../../utils/utils';
import { Typography } from '../../../atoms/typography/Typography';
import CompareTextSectionMobile from './compareTextSectionMobile/CompareTextSectionMobile';

const CompareTextSection = ({ title, items, systems, renderValue }) => (
  <div className="flex flex-col">
    {/* Mobile Section */}
    {/* <CompareTextSectionMobile
      title={title}
      items={items}
      systems={systems}
      renderValue={renderValue}
    /> */}
    {/* Desktop Section */}
    <div className="flex flex-row justify-between">
      <div className="flex flex-1 flex-col">
        {items.map((item, index) => (
          <div key={index} className="flex flex-row gap-1 sm:gap-5">
            <div className="hidden lg:flex flex-1 flex-col py-1">
              {/* index === 0 && (
                  <Typography
                    fontVariant="h7"
                    textAlign="left"
                    className="font-bold h-8 line-clamp-1 py-1"
                  >
                    {title}
                  </Typography>
                 
                <Typography
                  textAlign="left"
                  className="border-t border-primary-200 pt-1 lg:hidden"
                >
                  {item.text}
                </Typography>
                */}
            </div>
            {systems.map((system, i) => (
              <div
                key={i}
                className={cx(
                  `flex flex-1 flex-col shadow-md divide-y divide-primary-200 p-1 sm:px-5 ${getColorClass(i)}`,
                  {
                    'pt-9 rounded-t-xl': index === 0,
                    'rounded-b-xl mb-2': index === items?.length - 1,
                    [getColorClass(i)]: true,
                  }
                )}
              >
                <div
                  className={cx('gap-3 pb-3', {
                    'pt-5': index !== 0,
                  })}
                >
                  {item?.iconImg && item.iconImg}
                  <Typography
                    textAlign="left"
                    className="pt-1"
                    as="h3"
                    fontVariant="h7"
                  >
                    {item.text}
                  </Typography>
                </div>
                <div className="border-t border-primary-200 py-3">
                  {renderValue(system, item)}
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default CompareTextSection;
